// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ac774de5b291210f","9197":"1c2d2fae9635b123"}[chunkId] + ".css";
};